<template lang="pug">
v-container.pa-8(fluid)
  //- Title
  .text-2xl.font-semibold.neutral700--text Billings
  v-row.pb-2.pb-md-0(no-gutters)
    v-col
      v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen" active-class="font-semibold")
        v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
        v-tab.text-sm.font-medium.text-none.px-4 Paid
        v-tab.text-sm.font-medium.text-none.px-4 Outstanding panel
        v-tab.text-sm.font-medium.text-none.px-4 Outstanding self-pay
    v-col(cols="4")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat :placeholder="$t('type_to_search')" hide-details clearable autofocus)
        div
          customize-column-menu(type="billing" :showTooltip="false" iconSize="21")

  //- filter-row.my-2(:filters.sync="filters" ref="filter")
  .data-table
    v-data-table.mt-sm-4.pb-6.table-custom(:headers="headers" :items="bills" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" disable-sort :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="selectBill")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      //- amount
      template(v-slot:item.amount="{ item }")
        div.font-medium.neutral700--text {{ item.total_amount | displayPrice($currency) }}
      //- name
      template(v-slot:item.name="{ item }")
        div.neutral700--text {{ item.customer.name }}
      //- status
      template(v-slot:item.status="{ item }")
        y-chip(v-if="item.paid" label="Paid" color="green")
          template(#prepend)
            v-icon.mr-1(size="12" color="success600") mdi-record
        y-chip(v-else label="Outstanding" color="red")
          template(#prepend)
            v-icon.mr-1(size="12" color="danger600") mdi-record
      //- invoice no
      template(v-slot:item.invoice_no="{ item }")
        div.neutral700--text Bill {{ '#' + item.rid }}
      //- payment methods
      template(v-slot:item.payment="{ item, index }")
        div(:id="`pm-${index}`" style="position: relative;")
        div.d-flex.align-center.my-2
          template(v-for="txnarray in filteredArrays(item.transactions)")
            y-chip(:label="txnarray.payment_method" size="sm" chip-class="pa-1 mr-2" :key="txnarray.id" outlined)
          v-tooltip(v-if="item.transactions.length !== filteredArrays(item.transactions).length" top :attach="`#pm-${index}`" color="neutral700")
            template(#activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on")
                y-chip.cursor-help(v-bind="attrs" v-on="on" :label="`+${item.transactions.length - filteredArrays(item.transactions).length} more`" size="sm" chip-class="pa-1" outlined)
            div
              div(v-for="(pay, index) in item.transactions" :key="pay.id") {{ index + 1 }}. {{ pay.payment_method }}
      //- claim status
      template(v-slot:item.claim_status="{ item, index }")
        div(:id="`cs-${index}`" style="position: relative;")
        div.d-flex.align-center.my-2
          div(v-if="panels(item).length > 0")
            y-chip(:label="`${panels(item)[0].payment_method}: ${getClaimStatus(panels(item)[0].claim_status, 'text')}`" :color="getClaimStatus(panels(item)[0].claim_status, 'chip')" chip-class="pa-1 mr-2" outlined)
              template(#prepend)
                v-icon.mr-1(size="12" :color="getClaimStatus(panels(item)[0].claim_status, 'icon')") mdi-record
          v-tooltip(v-if="panels(item).length > 1" top :attach="`#cs-${index}`" color="neutral700")
            template(#activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on")
                y-chip.cursor-help(v-bind="attrs" v-on="on" :label="`+${panels(item).length - 1} more`" size="sm" chip-class="pa-1" outlined)
            div
              template(v-for="(panel, idx) in panels(item)")
                div(:key="`panel-${idx + 1}`") {{ idx + 1 }}. {{ `${panel.payment_method}: ${getClaimStatus(panel.claim_status, 'text')}` }}
      //- record date
      template(v-slot:item.record_date="{ item }")
        div.neutral700--text {{ item.record_date | humanizeDate }}
      //- actions
      template(v-slot:item.actions="{ item, index }")
        v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
          template(#activator="{ on }")
            v-btn(icon small v-on="on")
              v-icon mdi-dots-horizontal
          v-list.py-0
            v-list-item(@click="")
              v-list-item-title.text-sm.basic800--text Edit item
            v-divider
            v-list-item(@click="")
              v-list-item-title.text-sm.basic800--text Stock history

  div.d-flex.align-center.mb-4(v-if="totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
  
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
// import FilterRow from '@/components/clinic/inventory/FilterRow.vue'

export default {
  components: {
    CustomizeColumnMenu,
    // FilterRow
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    tabs: 0,
    bills: [],
    selectedBills: [],
    filters: [],
    tabItems: ['all', 'paid', 'outstanding_panel', 'outstanding_self_pay'],
    selectedPatient: null,
    showFilterDrawer: false,
    showSearchField: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      fields: 'clinic/getBillingFields'
    }),
    headers() {
      const filteredOptions = this.fields.filter(item => item.enable)
      const amount = {
        text: 'Amount',
        value: 'amount',
        class: 'text-table-header'
      }
      filteredOptions.map(item => {
        item.text = item.field_name
        item.value = `${item.id}`.toLowerCase()
        item['class'] = 'text-table-header'
      })
      return [amount, ...filteredOptions]
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    },
    patientId () {
      if (this.$route.params.id) return parseInt(this.$route.params.id)

      return null
    },
  },
  watch: {
    tabs (val) {
      const paramName = this.tabItems[val].toLowerCase()
      this.$router.push({ query: { ...this.$route.query, subtab:paramName } }).catch(() => {})
      this.searchText = null
      // this.$refs.filter.resetFilters()
      this.fetchInvoices(1)
    },
    pageSize() {
      this.fetchInvoices(1)
    },
    filters () {
      this.fetchInvoices(1)
    },
  },
  created () {
    this.checkRoute()
  },
  methods: {
    ...mapActions(['showMessage']),
    addFilter() {
      this.showFilterDrawer = true
    },
    fetchInvoices (page) {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page,
        company: this.company.id,
        form_type: 'registration',
        customer: this.patientId,
        omit: 'products,payment_methods'
      }
      if (this.tabs === 1) { params.paid = true }
      if (this.tabs === 2) { params.paid = false; params.default_payment = 'panel' }
      if (this.tabs === 3) { params.paid = false; params.default_payment = 'self-pay' }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/invoices`, { params })
        .then(resp => {
          const data = resp.data
          this.bills = data.results
          this.bills.map(item => {
            item.checked = false
          })
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    pageChanged(num) {
      this.fetchInvoices(num)
    },
    queryChanged: debounce(function () {
      this.fetchInvoices(1)
    }, 750),
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    selectBill (data) {
      // this.$router.push(`/admin/clinic/checkout/${data.pid}`)
      let params = { pid: data.pid, origin: 'ClinicPatientDetails', data: { params: { id: this.patientId }, query: { ...this.$route.query } }}
      this.$router.push({ name: 'ClinicCheckout', params }).catch(() => {})
    },
    panels (item) {
      return item.transactions.filter(f => f.channel === 'panel') || []
    },
    getClaimStatus (claim, type) {
      if (type === 'text') {
        switch(claim) {
          case 'received':
            return 'Claim received'
          default:
            return `${claim.charAt(0).toUpperCase()}${claim.slice(1)}`
        }
      } else if (type === 'chip') {
        switch(claim) {
          case 'new':
            return 'normal'
          case 'submitted':
            return 'yellow'
          case 'approved':
            return 'blue'
          case 'received':
            return 'green'
          case 'rejected':
            return 'red'
          default:
            return 'normal'
        }
      } else if (type === 'icon') {
        switch(claim) {
          case 'new':
            return 'neutral500'
          case 'submitted':
            return 'warning500'
          case 'approved':
            return 'info500'
          case 'received':
            return 'success500'
          case 'rejected':
            return 'danger500'
          default:
            return 'neutral500'
        }
      } else {
        return claim
      }
    },
    checkRoute() {
      if (this.$route.query.subtab) {
        this.tabs = this.tabItems.findIndex(item => item === this.$route.query.subtab)
        return
      }
      this.fetchInvoices(1)
    },
    filteredArrays (arrays) {
      if (arrays.length > 1) {
        let newArray = []
        let count = 0
        arrays.forEach((o, idx) => {
          count += o.payment_method.length
          if (idx === 0 || count <= 25) {
            newArray.push(o)
          }
        })
        return newArray
      }
      return arrays
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.bills.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .table-custom {
    .v-data-table__wrapper {
      overflow: visible !important;
    }
  }
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.v-tooltip__content {
  top: unset !important;
  left: unset !important;
  /* margin-top: -45px !important; */
  position: absolute;
  bottom: 0;
}
</style>